/**********************/
/* User login ACTIONS */
/**********************/
import * as actionTypes from "../actionTypes";
import axios from "../../../axios";

export const userLoginStart = () => {
  return {
    type: actionTypes.LOGIN_START
  };
};
export const userLoginSuccess = (token) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    token: token
  }
};
export const userLoginFail = (error) => {
  return {
    type: actionTypes.LOGIN_FAIL,
    error: error
  }
};
export const userLogin = (email, password) => {
  return dispatch => {
    dispatch(userLoginStart());
    const loginData = {
      username: email,
      password: password
    };
    axios.post('/authentication', loginData)
      .then(response => {
        //console.log('userLogin AXIOS response ', response.data.data);
        const token = response.data.data.token;
        localStorage.setItem('token', token);
        dispatch(userLoginSuccess(token));
      })
      .catch(err => {
        //console.log('userLogin AXIOS catch err ', err.response.data);
        dispatch(userLoginFail(err.response.data));
      });
  }
};